// extracted by mini-css-extract-plugin
module.exports = {"layout":"kf"};